import { stringify as stringifyQs } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

// import urlJoin from "url-join";

const ProductCategoriesReportSection = "/reports/bi/product-categories";

export const ProductCategoriesReportListPath = ProductCategoriesReportSection;

export enum ProductCategoriesBiListUrlFiltersEnum {
  query = "query",
  level = "level"
}

export type ProductCategoriesBiListUrlDialog =
  | "add"
  | "download"
  | TabActionDialog;
export type ProductCategoriesBiListUrlFilters = Filters<
  ProductCategoriesBiListUrlFiltersEnum
>;

export type ProductCategoriesBiListUrlQueryParams = ActiveTab &
  ProductCategoriesBiListUrlFilters &
  BulkAction &
  Dialog<ProductCategoriesBiListUrlDialog> &
  Pagination &
  SingleAction;

export const ProductCategoriesBiListUrl = (
  params?: ProductCategoriesBiListUrlQueryParams
) => ProductCategoriesReportListPath + "?" + stringifyQs(params);
